import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css'
import logo from '../assets/branding/thumb_2logo.png'
import instagram from '../assets/instagram.svg'
import facebook from '../assets/facebook.svg'
import x from '../assets/x-twitter.svg'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footer-logo">
                <img src={logo} alt="" />


            </div>
            <div className='footer-links-container'>
                <div>
                    <h3>Discover</h3>
                    <ul className='footer-links'>
                        <Link to='/all'><li>Shop all</li></Link>
                        <Link to='/birthday'><li>Birthday</li></Link>
                        <Link to='/wedding'><li>Wedding</li></Link>
                        <Link to='/engagement'><li>Engagement</li></Link>

                    </ul>
                </div>

                <div>
                    <h3>Get help</h3>
                    <ul className='footer-links'>
                        <Link to='/faqs'><li>FAQs</li></Link>
                        <Link to='/contact'><li>Contact</li></Link>
                    </ul>
                </div>

                <div>
                    <h3>Company</h3>
                    <ul className='footer-links'>
                        <Link to='/about-us'><li>About Us</li></Link>
                        <Link to='/blog'><li>Bastard Blog</li></Link>

                    </ul>
                </div>

                <div>
                    <h3>Legal</h3>
                    <ul className='footer-links'>
                        <Link to='/terms-of-use' ><li>Terms of use</li></Link>
                        <Link to='/privacy' ><li>Privacy Policy</li></Link>
                        <Link to='/cookie' ><li>Cookie Policy</li></Link>
                    </ul>
                </div>

            </div>

            <div className="footer-social-icons">
                <div className="footer-icons-container">
                    <img src={instagram} alt="" />
                </div>
                <div className="footer-icons-container">
                    <img src={facebook} alt="" />
                </div>
                <div className="footer-icons-container">
                    <img src={x} alt="" />
                </div>
            </div>
            <div className="footer-copyright">
                <hr />
                <p>Bastard Cards © {new Date().getFullYear()} - All Rights Reserved.</p>
            </div>
        </div>
    )
}

export default Footer